export default __webpack_public_path__ + "static/media/19_tag_paid-beauty-salon.bb15ef9a.svg";